import Styles from "./view_list.module.css";
import { List } from "./view_list_components";
import testImg from "../../images/11905945_4857949.jpg";
export const ViewListBody = ( props ) => {
    const {  } = props;
    const { Content } = Styles;
    const list = {
        image: testImg,
        imageTheme: "#ffc107",
        Attribute: {
            filesNumber: "12files",
            size: "3GB",
            payment : "FREE",
            paymentTheme: "#4caf50",
            link    : "List Link",
            lastVersion: "download last version",
        },
        listName: "List Name test",
        listNameTheme: "#607d8b",
        listNameIcon: <i className="bi bi-feather"></i>,
        rate: <><i style={{ margin: "0 5px" }} className="bi bi-star-fill"></i><i style={{ margin: "0 5px" }} className="bi bi-star-fill"></i><i style={{ margin: "0 5px" }} className="bi bi-star-fill"></i><i style={{ margin: "0 5px" }} className="bi bi-star-half"></i><i style={{ margin: "0 5px" }} className="bi bi-star"></i></>,
        rateTheme: "#ffc107",
        rateIcon: <i className="bi bi-bookmark-star-fill"></i>,
        teamTitle: "Creators",
        teamTitleIcon: <i className="bi bi-people-fill"></i>,
        teamSection: [
            { icon: <i className="bi bi-person-vcard-fill"></i>, text: "Crypto", theme: "#795548", link: null },
            { icon: <i className="bi bi-person-vcard-fill"></i>, text: "Eta", theme: "#795548", link: null },
        ],
        date: "2024/9/17",
        sections: [
            { code: "std::cout << 'Hello, World! << std::endl;", codeType: "C++", codeTheme: "lightgray", image: testImg, imageTheme: "#ffc107", title: "Article", text: " noun markers that function to specify if the noun is general or specific in its reference. Often the article chosen depends on if the writer and the " },
        ],
        captionTheme: "gray",
        captionColor: "lightgray",
        warnings:[
            {
                title: "Hola Amigo",
                text: "A second common modern English style is to use no indenting, but add vertical white space to",
                headline: "HJKgibkKfg==",
                headlineIcon: <i className="bi bi-unlock-fill"></i>,
                width: 315,
            }
        ],
        contentListTitle: "Different Versions ",
        contentListIcon: <i className="b bi-cpu-fill"></i>,
        cells: [
            { isLock: true, name: "paradox.2.0.apk", date: "2024/10/17", size: "313MB", files: "1files", link: null, theme: "", color: "" },
            { isLock: true, name: "paradox.1.9.apk", date: "2024/10/17", size: "288MB", files: "1files", link: null, theme: "", color: "" },
            { isLock: true, name: "paradox.1.5.apk", date: "2024/10/17", size: "275MB", files: "1files", link: null, theme: "", color: "" },
            { isLock: true, name: "paradox.1.2.apk", date: "2024/10/17", size: "180MB", files: "1files", link: null, theme: "", color: "" },
        ]
    };
    return (
        <main className={ Content }>
            <List list={ list }/>
        </main>
    );
};